"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RemindersContainer = void 0;

var _react = _interopRequireDefault(require("react"));

require("./RemindersContainer.scss");

var _CrossMedium = _interopRequireDefault(require("@react/react-spectrum/Icon/core/CrossMedium"));

var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));

var _reactTransitionGroup = require("react-transition-group");

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _adobeIntlReact = require("@adobe/adobe-intl-react");

var _Constants = require("../../constants/Constants");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var RemindersContainer = function RemindersContainer(props) {
  var reminders = props.reminders,
      closeHandler = props.closeHandler,
      formatMessage = props.formatMessage,
      locale = props.locale,
      localeData = props.localeData,
      onReminderClosed = props.onReminderClosed,
      serverTimeStamp = props.serverTimeStamp,
      clientTimeStamp = props.clientTimeStamp;
  return _react.default.createElement("div", {
    className: "reminder-conatiner"
  }, _react.default.createElement("div", {
    className: "reminder-header"
  }, reminders.length > 1 ? _react.default.createElement("div", null, formatMessage({
    messageId: 'Reminders',
    defaultMessage: localeData['en-US'].Reminders,
    description: 'Reminders'
  }), " (".concat(reminders.length, ")")) : _react.default.createElement("div", null, formatMessage({
    messageId: 'Reminder',
    defaultMessage: localeData['en-US'].Reminder,
    description: 'Reminder'
  })), _react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
    placement: "top",
    trigger: "hover"
  }, _react.default.createElement("div", {
    className: "reminder-close",
    onClick: function onClick() {
      return closeHandler();
    }
  }, _react.default.createElement(_CrossMedium.default, {
    size: null
  })), _react.default.createElement(_Tooltip.default, null, reminders.length > 1 ? formatMessage({
    messageId: 'Dismiss all reminders',
    defaultMessage: localeData['en-US'].DismissAllReminders,
    description: 'Dismiss all reminders'
  }) : formatMessage({
    messageId: 'Dismiss reminder',
    defaultMessage: localeData['en-US'].DismissReminder,
    description: 'Dismiss reminder'
  })))), _react.default.createElement("div", {
    className: "reminder-list"
  }, _react.default.createElement(_reactTransitionGroup.TransitionGroup, null, reminders.map(function (entry) {
    /*
        *as per design we need to show notification's read mode style for reminder
        *hence changing isRead to true
        */
    entry.isRead = true;
    entry.fromReminder = true;
    return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
      classNames: "pulse-alert",
      key: entry.id,
      timeout: 500
    }, _react.default.createElement(_PulseNotificationMessageWrapper.default, {
      clientTimeStamp: clientTimeStamp,
      isFloatingAlert: false,
      isReminder: true,
      locale: locale,
      onMessageCloseClicked: function onMessageCloseClicked() {
        return onReminderClosed(entry.id);
      },
      pulseMessageObject: entry,
      renderCrossButton: reminders.length > 1,
      serverTimeStamp: serverTimeStamp
    }));
  }))));
};

exports.RemindersContainer = RemindersContainer;

var _default = (0, _adobeIntlReact.withLocalization)(RemindersContainer);

exports.default = _default;